<template>
  <section :class="['section', 'child-view']">
    <div class="wrapper">
      <div class="title-area">
        <h1>Who we are</h1>
        <p class="description">People are at the heart of our organization. We are dedicated to fostering robust professional relationships, turning pursuit of every goal into an exciting journey.</p>
      </div>
      <div class="team-numbers-info">
        <h2 class="team-numbers-title">Our team</h2>
        <ul class="team-numbers-list">
          <li>
            <p class="team-number">{{ employees.length }}</p>
            <p class="team-info">designers</p>
          </li>
          <li>
            <p class="team-number"><span class="plus">+</span>320</p>
            <p class="team-info">projects</p>
          </li>
          <li>
            <p class="team-number">{{ yearsOfExperience }}</p>
            <p class="team-info">years</p>
          </li>
        </ul>
      </div>
      <div class="content">
        <ul
          class="people-list"
          ref="peopleList"
        >
          <li
            class="people-list-item"
            v-for="(employee, index) in employees"
            :key="index"
          >
            <div class="people-list-visual">
              <div class="people-list-avatar">
                <img :src=employee.avatar.path>
              </div>
              <div class="people-list-name">
                <span ref="firstName">{{ employee.first_name }}</span>
                <span ref="lastName">{{ employee.last_name }}</span>
              </div>
              <div class="people-list-position">
                {{ employee.position }}
                <span class="people-list-experience">
                  {{ employee.experience }}+ <span>years</span>
                </span>
              </div>
              <div class="people-list-info">
                <div class="people-list-expertise">
                  <span class="expertise-text">Expert in:</span>
                  <ul class="expertise-list">
                    <li
                      v-for="(expertise, index) in employee.expert_in"
                      :key="index"
                    >
                      {{ expertise }}
                    </li>
                  </ul>
                </div>
                <div class="self-presentation">{{ employee.description }}</div>
                <div class="people-list-domains">
                  <span class="domains-text">Domains:</span>
                  <ul class="domains-list">
                    <li
                      v-for="(domain, index) in employee.domains"
                      :key="index"
                    >
                      {{ domain }}
                    </li>
                  </ul>
                </div>
                <ul class="list-tools">
                  <li
                    v-if="toolsIcons[tool]"
                    v-for="(tool, index) in employee.programs"
                    :key="index"
                  >
                    <img :src="toolsIcons[tool]">
                    <span class="tooltip">{{ toolsNames[tool] }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <Footer></Footer>
    </div>
  </section>
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapActions, mapGetters } from 'vuex';

import SquareDummy from '@/components/SquareDummy';
import Video from '@/components/Video';
import Footer from '@/components/UI/Footer';

import { fitTextToBlock, toolsIcons, toolsNames } from '@/utils/helpers';

export default {
  components: {
    SquareDummy,
    Video,
    Footer,
  },
  data() {
    return {
      toolsIcons,
      toolsNames,
    };
  },
  computed: {
    ...mapGetters({
      employees: 'employees/employees:get',
    }),
  },
  created() {
    this.yearsOfExperience = this.getYearsOfExperience();
    if (this.employees.length < 1) {
      this.fetchEmployees();
    }
  },
  mounted() {
    window.addEventListener('resize', this.setNameSize);
    this.setNameSize();
  },
  updated() {
    this.setNameSize();
  },
  methods: {
    ...mapActions({
      fetchEmployees: 'employees/employees:fetch',
    }),
    getYearsOfExperience() {
      const companyDOB = new Date('2009-11-07');
      const currentDate = new Date();
      const timeDifference = currentDate - companyDOB;
      const millisecondsInYear = 1000 * 60 * 60 * 24 * 365.25;
      const yearsDifference = timeDifference / millisecondsInYear;
      return Math.floor(yearsDifference);
    },
    getLongestNameIndex() {
      const firstNames = this.employees.map(dataItem => dataItem.first_name);
      const lastNames = this.employees.map(dataItem => dataItem.last_name);

      const {
        name: firstName,
        nameIndex: fistNameIndex,
      } = this.getLongestNameIndexPart(firstNames);
      const { name: lastName, nameIndex: lastNameIndex } = this.getLongestNameIndexPart(lastNames);

      let nameIndex = 0;
      let nameType = '';

      if (firstName.length > lastName.length) {
        nameIndex = fistNameIndex;
        nameType = 'firstName';
      } else {
        nameIndex = lastNameIndex;
        nameType = 'lastName';
      }

      return { nameIndex, nameType };
    },
    getLongestNameIndexPart(names) {
      let name = '';
      let nameIndex = 0;

      names.forEach((item, i) => {
        if (item.length > name.length) {
          name = item;
          nameIndex = i;
        }
      });

      return { name, nameIndex };
    },
    setNameSize() {
      const { nameIndex, nameType } = this.getLongestNameIndex();
      const { peopleList } = this.$refs;

      if (this.$refs[nameType] && this.$refs[nameType][nameIndex]) {
        const name = this.$refs[nameType][nameIndex];
        fitTextToBlock(peopleList, name);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/AboutUs.vue